import { contentListIdsState } from "@/stores/cart";
import React from "react";
import { useRecoilState } from "recoil";
import AllCheckBox from "../AllCheckBox";
import CartButton from "../CartButton";
import HelperButton from "../HelperButton";
import TranslateAllButton from "../TranslateAllButton";
import styles from "./styles.module.less";

interface IProps {
  term: string;
  verbose: boolean;
  pmids: string[];
}

const ContentHeader: React.FC<IProps> = ({ term, verbose, pmids }) => {
  const [ids, _setIds] = useRecoilState(contentListIdsState);
  const setIds = (ids: string[]) => _setIds(ids);

  return (
    <div
      className={styles.container}
      style={{ paddingLeft: verbose ? "8px" : 0 }}
    >
      <HelperButton />
      <TranslateAllButton ids={pmids} />
      <AllCheckBox verbose={verbose} pmids={pmids} ids={ids} setIds={setIds} />
      <CartButton verbose={verbose} />
      <div>
        {term}
        <sub className={styles.sub}> on Pubmed</sub>
      </div>
    </div>
  );
};

export default ContentHeader;
